// Soal pengembangan Bahasa Indonesia yang dibundel di aplikasi (pengembangan/*.json, formatnya
// sama dengan bank soal). Dinormalisasi sekali saat pertama dipakai.
import { normalisasiBankSoal } from '../../content/validasi.js';

const FILE = import.meta.glob('./pengembangan/*.json', { eager: true, import: 'default' });
let cache = null;

export function soalPengembangan() {
  if (cache) return cache;
  cache = Object.entries(FILE).sort(([a], [b]) => a.localeCompare(b)).flatMap(([f, raw]) => {
    const { soal, galat } = normalisasiBankSoal(raw, { mapel: 'bahasa-indonesia' });
    if (galat.length) console.warn(`Soal pengembangan ${f} bermasalah:\n` + galat.join('\n'));
    return soal.map(q => ({ ...q, sumber: 'pengembangan' }));
  });
  return cache;
}
